export default __webpack_public_path__ + "files/missouri-6b294348793b695c8cdad8d4fd2f4cae.png";